<template>

</template>

<script>
    import AlertMixin from "../mixins/alertMixin";

    export default {
        name: "RegisterUser",
        mixins: [AlertMixin],
        props: ['user', 'token'],
        data() {
            return {
                userdata: {
                    email: this.user.email,
                    name: this.user.name,
                    token: this.token,
                    password: '',
                    password_confirmation: ''
                },
                disabled: true,
                disableRenterPassword: true,
                feedback: '',
                secondpassword: '',
                feedbackcontent: '',
                has_number: false,
                has_lowercase: false,
                has_uppercase: false,
                has_special: false,
                validPass: false,
                errors: [],
                spinnerClass: "zmdi zmdi-check"
            }
        },
        methods: {
            passwordValidation() {
                this.has_number = /\d/.test(this.userdata.password);
                this.has_lowercase = /[a-z]/.test(this.userdata.password);
                this.has_uppercase = /[A-Z]/.test(this.userdata.password);
                this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.userdata.password);
            },
            passwordCheck() {
                this.passwordValidation(); //for input detection
                if(this.userdata.password.length > 0) {
                    this.passwordValidation(); //for when at-least one character has been entered in password field
                    this.disabled = true;
                    this.disableRenterPassword = false;
                    if (this.passwordCriteria() === true) {
                        if (this.userdata.password === this.secondpassword) {
                            this.disabled = false;
                            this.validPass = true;
                            this.isvalid = 'form-control is-valid';
                            this.feedback = 'valid-feedback text-cf-light-green';
                            this.feedbackcontent = 'Passwords match';
                        } else {
                            this.disabled = true;
                            this.validPass = false;
                            this.isvalid = 'form-control is-invalid';
                            this.feedback = 'invalid-feedback';
                            this.feedbackcontent = 'Please ensure passwords match';
                        }
                    } else {
                        this.disabled = true;
                        this.validPass = false;
                        this.isvalid = 'form-control';
                        this.feedback = '';
                        this.feedbackcontent = '';
                    }
                } else {
                    this.disableRenterPassword = true;
                    this.disabled = true;
                    this.validPass = false;
                    this.isvalid = 'form-control';
                    this.feedback = '';
                    this.feedbackcontent = '';
                }
            },
            passwordCriteria() {
                return this.has_number &&
                    this.has_special &&
                    this.has_uppercase &&
                    this.has_lowercase &&
                    this.userdata.password.length > 9;
            },
            submitDetails() {
                let app = this;
                if(this.validPass === true) {
                    this.userdata.password_confirmation = this.secondpassword;
                    app.spinnerClass = "spinner-grow";
                    axios.post("/user/activate", app.userdata, {
                        headers:{
                            'Content-Type':'application/json',
                        }
                    }).then(function(response) {
                        app.spinnerClass = "zmdi zmdi-check";
                        app.fireSuccessAlert({
                            title: 'Success!',
                            text: "Your user details have been set",
                            buttonsStyling: false,
                            cancelButtonClass: "btn btn-danger rebrand-login-button",
                            confirmButtonClass: "btn btn-primary rebrand-login-button",
                            onConfirm: () => {window.location.href = "/login"} //back-end does redirect, but this is here also just in-case
                        })
                    })
                    .catch(error => {
                        if(error.response.data.activationExpired) {
                            window.location.href = "/user/register/" + this.token;
                        }
                        app.spinnerClass = "zmdi zmdi-check";
                        this.errors = [];
                        app.disabled = false;

                        this.errors = error.response.data.errors;
                    });
                }
            }
        }
    }
</script>
